import React from "react";

type PDFViewerProps = {
  file: any;
  fileName: string;
  showTitle?: boolean;
  overflowHidden?: boolean;
};

const PDFViewer: React.FC<PDFViewerProps> = ({
  file,
  fileName,
  showTitle,
  overflowHidden,
}) => {
  const styles: React.CSSProperties = {
    overflow: "hidden",
  };
  return (
    <div className="PDFViewer">
      <div className="Contents">
        {showTitle && <h3>{fileName}</h3>}
        <object
          data={file.preview ? file.preview : file}
          style={overflowHidden ? styles : undefined}
          type="application/pdf"
          width="100%"
          height="100%"
        >
          <p>pdf viewer</p>
        </object>
      </div>
    </div>
  );
};

export default PDFViewer;
